export default __webpack_public_path__ + "static/media/yellow.4947113e.png";